export default __webpack_public_path__ + "static/media/melayu_description.b7522d4f.png";